import { Box } from '@osmosis/tailwind-ui/components/Box';
import { Flex } from '@osmosis/tailwind-ui/components/Box';
import React from 'react';
import headingSchema from '../../../lib/composer/schemas/heading';
import subheadingSchema from '../../../lib/composer/schemas/subheading';
import textSchema from '../../../lib/composer/schemas/text';
import { MediaAndTextListBlockProps } from '../../../types/composer';
import themeSchema from '../../../lib/composer/schemas/theme';
import BlockWrapper from '../BlockWrapper';
import Heading from '../block-ui/Heading';
import Subheading from '../block-ui/Subheading';
import RichText from '../block-ui/RichText';
import MediaAndText from './MediaAndText';
import mediaListSchema from '../../../lib/composer/schemas/mediaList';

type Props = MediaAndTextListBlockProps;

/**
 * Media and text list block.
 */
const MediaAndTextList = (props: Props) => {
  const {
    heading,
    subheading,
    text,
    theme = '',
    anchor,
    list = [],
    topHeader,
  } = props;

  return (
    <Box id={anchor}>
      <BlockWrapper>
        <Flex className={`flex-col gap-3 items-center`}>
          {heading && (
            <Heading text={heading} theme={theme} topHeader={topHeader} />
          )}
          {subheading && (
            <Subheading text={subheading} theme={theme} topHeader={topHeader} />
          )}
          {text && <RichText html={text} theme={theme} alignment="center" />}
        </Flex>
        {!!list.length && (
          <Box className={`mt-4`}>
            {list.map((args, i) => (
              <MediaAndText
                key={i}
                {...{ ...args, theme, renderBlockWrapper: false }}
              />
            ))}
          </Box>
        )}
      </BlockWrapper>
    </Box>
  );
};

export default MediaAndTextList;

MediaAndTextList.schema = {
  name: 'media-and-text-list',
  label: 'Media and text list',
  editableProps: [
    headingSchema,
    subheadingSchema,
    textSchema,
    mediaListSchema,
    themeSchema,
  ],
};
